module.exports = __webpack_public_path__ + "static/media/nasal_cushion.afd8b822.png";